import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import { Tooltip } from '@mui/material';
import MerchantDetails from './components/MerchantDetails';
import HubIcon from '@mui/icons-material/OtherHouses';
import CloseIcon from '@mui/icons-material/Close';
import { LinearProgress, SnackbarContent } from '@mui/material';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

import Badge from "react-bootstrap/Badge";
const MerchantDetailsIndex = () => {
  useEffect(() => {
    getAllMerchantDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllMerchantDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllMerchantDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },

      {
        Header: 'Merchant Name',
        accessor: 'merchantName',
        disableGlobalFilter: true,
      },

      {
        Header: 'Merchant Code',
        accessor: 'merchantCode',
        disableGlobalFilter: false,
      },
      {
        Header: 'Merchant Branch',
        accessor: 'merchantBranch',
        disableGlobalFilter: false,
      },
      {
        Header: 'Contact Name',
        accessor: 'merchantContactName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Contact No',
        accessor: 'merchantContactMobileNo',
        disableGlobalFilter: true,
      },
      {
        Header: "Hub Status",
        accessor: "hubInfo",
        disableSortBy: true,
         Cell: ({ row }) => (
          <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
            {row.original.hubId != null ? (
              <Tooltip title="Hub is assigned to this Merchant">
                <HubIcon style={{ fontSize: '24px', color: '#2f6710', marginRight: '4px' }} />
              </Tooltip>
            ) : (
              <Tooltip title="Hub is not assigned to this Merchant">
                <CloseIcon style={{ fontSize: '24px', color: 'red', marginRight: '4px' }} />
              </Tooltip>
            )}
          
          </div>
        ),
      },
      {
        Header: 'Primary Hub Name',
        accessor: 'hubName',
        disableGlobalFilter: true,
      },
      {
        Header: "Opn. Status",
        accessor: "status",
        disableSortBy: true,
       
        Cell: ({ row }) =>
          row.original?.merchantStatus == 1 ? (
            <h6><Badge bg="success">ACTIVE</Badge></h6>
          ) :
            <h6><Badge bg="danger">IN-ACTIVE</Badge></h6>

      },


    ],
    [],
  );

  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <MerchantDetails reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <MerchantDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}

    </Container>
  );
};

export default MerchantDetailsIndex;